module.exports = __webpack_public_path__ + "img/idcardFrontUrl_shili.2fbdf979.png";